import { array, option } from "fp-ts";
import { ProductVariantAvailabilityStatus } from "@swo/shared";
import { pipe } from "fp-ts/lib/function";
import { ProductDetailPageDataShared } from "@swo/storefront";

export const outOfStock = (): ProductVariantAvailabilityStatus => ({
  tag: "out-of-stock" as const,
});

export function getProductAvailability(availability: ProductDetailPageDataShared["availability"]) {
  if (availability === "shopping-not-possible") {
    return null;
  }

  return (variantSku: string): ProductVariantAvailabilityStatus => {
    return pipe(
      availability.flatMap(f => (f.sku === variantSku ? [f.status] : [])),
      array.head,
      option.getOrElse<ProductVariantAvailabilityStatus>(outOfStock),
    );
  };
}
